import SecondSection from './SecondSection';

export default SecondSection;
